import { render, staticRenderFns } from "./video_input.vue?vue&type=template&id=3853353a&scoped=true&"
import script from "./video_input.vue?vue&type=script&lang=js&"
export * from "./video_input.vue?vue&type=script&lang=js&"
import style0 from "./video_input.vue?vue&type=style&index=0&id=3853353a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3853353a",
  null
  
)

export default component.exports